import { render, staticRenderFns } from "./CanvasLayout.vue?vue&type=template&id=1dafb25a&scoped=true"
import script from "./CanvasLayout.vue?vue&type=script&lang=js"
export * from "./CanvasLayout.vue?vue&type=script&lang=js"
import style0 from "./CanvasLayout.vue?vue&type=style&index=0&id=1dafb25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dafb25a",
  null
  
)

export default component.exports